<!--
* @Author : ShaJiaJing
* @Date :  2019/5/29
* @Version : 1.0
* @Content : font组件
-->
<template>
  <i :class="`iconfont ${type}`"></i>
</template>

<script>
export default {
  name: 'BIcon',
  props: {
    type: {
      type: String,
      required: true
    }
  }
}
</script>
